import { MyCompetencies } from '../types/myCompetencies';
import { MyCompetenciesRaw } from '../types/myCompetenciesRaw';

export const myCompetencyAdapter = (myCompetenciesRaw: MyCompetenciesRaw): MyCompetencies => {
  const columns = {
    competency: {
      id: 'competency',
      displayName: myCompetenciesRaw.columns.competency.displayName,
      description: myCompetenciesRaw.columns.competency.description,
    },
    praise: {
      id: 'praise',
      displayName: myCompetenciesRaw.columns.praise.displayName,
      description: myCompetenciesRaw.columns.praise.description,
    },
    advice: {
      id: 'advice',
      displayName: myCompetenciesRaw.columns.advice.displayName,
      description: myCompetenciesRaw.columns.advice.description,
    },
    hierarchy: {
      id: 'hierarchy',
      displayName: myCompetenciesRaw.columns.hierarchy?.displayName,
      description: myCompetenciesRaw.columns.hierarchy?.description,
    },
  };

  if (myCompetenciesRaw.columns?.progress) {
    columns.progress = {
      id: 'progress',
      displayName: myCompetenciesRaw.columns.progress.displayName,
      description: myCompetenciesRaw.columns.progress.description,
    };
  }

  const rowData = myCompetenciesRaw.data.map((row) => {
    const rowObject = {
      competency: {
        uuid: row.competency.uuid,
        value: row.competency.value,
      },
      advice: {
        uuid: row.advice.uuid,
        value: row.advice.value,
      },
      praise: {
        uuid: row.praise.uuid,
        value: row.praise.value,
      },
      hierarchy: {
        uuid: row.hierarchy?.uuid,
        value: row.hierarchy?.value,
      },
      employee: {
        uuid: row.employee?.uuid,
        value: {
          id: row.employee?.value.id,
          displayName: row.employee?.value.displayName,
          profilePhoto: row.employee?.value.profilePhoto,
        },
      },
    };

    if (row?.progress) {
      rowObject.progress = {
        uuid: row.progress.uuid,
        value: {
          displayScore: row.progress.value.displayScore,
          maxScore: row.progress.value.maxScore,
          label: row.progress.value.label,
        },
      };
    }

    return rowObject;
  });

  return { columns, rowData };
};
